import React, { memo, useEffect, useRef, useState } from 'react'
import { classNames } from '@dt/fe-utils'
import { Icon, Input } from 'components'
import { IonContent, IonFooter, IonInput, IonModal } from '@ionic/react'
import './index.scss'

// props
interface IProps {
  /** 数量 */
  cnt: number;
  /** 最小 */
  min?: number;
  /** 最大 */
  max?: number;
  /** 主题 */
  theme?: 'default' | 'primary';
  /** 大小 */
  size?: 'small' | 'large';
  /** 隐藏减号 */
  hideMinus?: boolean;
  /** 样式类名 */
  className?: string;
  /** disabled */
  disabled?: boolean;
  /** change事件 */
  onChange: (isAdd: boolean, event: React.MouseEvent) => void;
  /** 通过键盘自定义编辑数量, 通过判断这个方法是否，存在去编辑 */
  onEdit?: (cnt: number, event: React.MouseEvent) => void;
  /** click事件 */
  onClick?: (event: React.MouseEvent) => void;
  uid?: string;
}

const Stepper: React.FC<IProps> = ({ cnt, min, max, theme = 'default', size = 'small', onEdit, hideMinus, className, disabled, onChange, onClick, uid = '' }) => {
  const [isEdit, setEdit] = useState<boolean>(false)
  const [editValue, setEditValue] = useState<number>(-1)
  const inputRef = useRef(null)
  // 处理change事件
  const handleChange = (isAdd: boolean, e: React.MouseEvent) => {
    if (disabled) return
    if (cnt === min && !isAdd) {
      return
    }
    if (cnt === max && isAdd) {
      return
    }
    onChange(isAdd, e)
  }
  // 处理edit事件
  const handleChangeEdit = (e: React.MouseEvent) => {
    setEdit(false)
    if (editValue === -1) return
    if (disabled) return
    if (editValue < min || editValue > max) {
      console.log('超过或者小于')
      return
    }
    try {
      onEdit(Number(editValue), e)
    } catch (error) { }
  }
  const handleEdit = () => {
    if (disabled) return
    if (onEdit) {
      setEdit(!isEdit)
    }
  }

  const handleInput = (value) => {
    setEditValue(value > 9999 ? 9999 : value)
  }

  useEffect(() => {
    if (isEdit) {
      inputRef?.current?.focus()
    } else {
      setEditValue(-1)
    }
  }, [isEdit])

  return (
    <>
      <div
        className={classNames(`stepper-wrapper ${theme}-theme ${size}-size`, {
          'no-minus': hideMinus,
          'disabled': disabled,
          className,
        })}
      >
        <div className='stepper-inner' data-cypid='stepperInner' onClick={onClick}>
          <span
            className={`step-minus-icon${cnt === min || disabled ? ' disabled' : ''}`}
            data-cypid={`stepMinus_${uid}`}
            onClick={(e: React.MouseEvent) => handleChange(false, e)}
          >
            <Icon name='minus-circle' />
          </span>
          <span className='step-cnt' data-cypid='stepperKeybroadShow' onClick={handleEdit}>{cnt}</span>
          <span
            className={`step-add-icon${cnt === max || disabled ? ' disabled' : ''}`}
            data-cypid={`stepAdd_${uid}`}
            onClick={(e: React.MouseEvent) => handleChange(true, e)}
          >
            <Icon name='tianjia' />
          </span>
        </div>
      </div>
      {isEdit && (
        <IonModal isOpen onDidDismiss={handleEdit} cssClass='stepper-keybroad-modal'>
          <IonContent data-cypid={`stepperEditClose_${uid}`} onClick={handleEdit}>
          </IonContent>
          <IonFooter>
            <div className='stepper-keybroad-container'>
              <div className='stepper-box-wrapper'>
                <div className='stepper-keybroad-wrapper'>
                  <span className='label'>{i18n.t('menu.inputCnt')}:</span>
                  <input
                    data-cypid={`stepperKeybroadInput_${uid}`}
                    onInput={(e: any) => handleInput(e.target.value)}
                    maxLength={4}
                    autoFocus
                    ref={inputRef}
                    className='input'
                    type='number'
                    pattern='\d*'
                    value={editValue > 0 ? editValue : ''}
                  />
                  <span className='btn' data-cypid={`stepperKeybroadConfirm_${uid}`} onClick={handleChangeEdit}>{i18n.t('common.finish')}</span>
                </div>
              </div>
            </div>
          </IonFooter>
        </IonModal>
      )}
    </>
  )
}

export default memo(Stepper)
